<main id="main" class="list-height volume-issue-main">
    <section class="pt-0 volume-issue-sec" aria-label="">
      <div class="container volume-issue-container">
  
        <!-- Header Skeleton -->
        <ng-container *ngIf="loading">
          <div class="row mb-4">
            <div class="skeleton-breadcrumb shimmer"></div>
            <div class="skeleton-heading shimmer mt-2"></div>
          </div>
        </ng-container>
  
        <!-- Real Header -->
        <ng-container *ngIf="!loading">
          <div class="row mb-4" *ngIf="themeSettingsData">
            <span class="article-breadcrumb-sec">
              <span (click)="goToPage('')" class="breadcrumb-nav">
                <i><span class="nav-string nav-string-home">
                  {{ themeSettingsData.banner_heading }}
                </span></i>
                <fa-icon class="angle-icon" [icon]="['fas', 'angle-right']"></fa-icon>
              </span>
              <span>Current Articles</span>
            </span>
  
            <div class="volume-head-title" data-aos="fade-up">
              <h1 tabindex="0">{{ volume_heading | translate }}</h1>
            </div>
          </div>
        </ng-container>
  
        <!-- Articles Skeleton -->
        <ng-container *ngIf="loading">
          <div class="row">
            <div class="col-6" *ngFor="let i of [1,2,3,4]">
              <div class="article-box-second article-box-second-space-between skeleton-article">
                <div class="row">
                  <div class="col-lg-4 col-md-6 col-sm-12">
                    <div class="skeleton-img-large shimmer"></div>
                  </div>
                  <div class="col-lg-8 col-md-6 col-sm-12">
                    <div class="skeleton-line-lg shimmer"></div>
                    <div class="skeleton-line-md shimmer"></div>
                    <div class="skeleton-block shimmer"></div>
                    <div class="skeleton-line-sm shimmer mt-2"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
  
        <!-- Real Articles -->
        <ng-container *ngIf="!loading">
          <div class="row">
            <div class="col-6" *ngFor="let article of current_article">
                <div class="article-box-second article-box-second-space-between">
                    <div class="article-info-second">
                        <div class="row">
                            <div class="col-lg-4 col-xl-4 col-xxl-4 col-md-6 col-sm-12 m-0">


                                <img class="article-explore-image" *ngIf="article.article_cover_image"
                                    src="{{articleCoverImageUrl+getArticleImageUrl(article)}}"
                                    alt="Cover image for the article" class="article-explore-image"
                                    [routerLink]="['/articles/'+article.volume+'/'+article.issue+'/'+article.article_id]">
                                <img *ngIf=" !article.article_cover_image && +article.volume <= 11"
                                    class="card-img-top rvh-article-default-cover"
                                    src="{{default_article_cover_image_upto_11}}" alt="Cover image for the article"
                                    [routerLink]="['/articles/' + article.volume + '/' + article.issue + '/' + article.article_id]">
                                <img *ngIf=" !article.article_cover_image && +article.volume >11"
                                    class="card-img-top rvh-article-default-cover-green"
                                    src="{{default_article_cover_image_above_11}}" alt="Cover image for the article"
                                    [routerLink]="['/articles/' + article.volume + '/' + article.issue + '/' + article.article_id]">
                            </div>
                            <div class="col-lg-8 col-xl-8 col-xxl-8 col-md-6 col-sm-12 ">

                                <div class="col">
                                    <div class="row">
                                        <div class="col-11 col-md-10">
                                            <a class="second-title" [title]=" getCleanTitle(article.article_title)"
                                                [routerLink]="['/articles/'+article.volume+'/'+article.issue+'/'+article.article_id]"
                                                [appWordClamp]="getFormattedTitle(article.article_title)">
                                                {{ getCleanTitle(article.article_title) }}
                                            </a>
                                        </div>
                                        <div class="col-1 col-md-2 d-flex justify-content-end pl-0">
                                            <img src='assets/logos/open_access_logo.webp'
                                                class="articlelist-open-access-logo-second" width="25" height="25"
                                                [ngbTooltip]="'article_listing.open_access'|translate"
                                                [placement]="'bottom'" alt="open access logo">
                                        </div>
                                    </div>
                                </div>


                                <h3 class="!loader" class="sub-title">
                                    {{
                                    getAuthorsString(article.authors) }}
                                </h3>

                                <div class="explore-content-second" [innerHTML]="article.abstract">

                                </div>
                                <div class="row mt-2 mb-0">
                                    <div class="col-6 doi-content-div">

                                        <span class="article-doi">

                                            <a [href]="ensureHttps(article.doi)" target="_blank"
                                                [title]=" ensureHttps(article.doi)" class="doi-underline">
                                                <fa-icon class="iconcls" aria-hidden="true"
                                                    [icon]="['fas', 'earth-americas']"></fa-icon>
                                                {{article.doi}}
                                            </a>
                                        </span>
                                    </div>
                                    <div class="col-6 text-end doi-content-div">
                                        <span class="article-doi"
                                            [ngbTooltip]="'article_listing.publisher_date'|translate"
                                            [placement]="'bottom'"><fa-icon class="iconcls" aria-hidden="true"
                                                [icon]="['fas', 'calendar-days']"></fa-icon>
                                            {{
                                            removeCommaFromDate(article.published_date) }}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
          </div>
        </ng-container>
  
      </div>
    </section>
  </main>
  


